import React from "react";

type UserType = {
    id: number,
    login: string,
    name: string,
    avatar: string
}

// Определяем тип контекста
type AuthContextType = {
    isAuthenticated: boolean; // флаг, показывающий, аутентифицирован ли пользователь
    setAuth: (auth: boolean) => void; // функция для изменения значения isAuthenticated
    roles: string[],
    setRoles: (roles: string[]) => void,
    user: UserType,
    setUser: (user: UserType) => void,
};

// Создаем контекст с типом AuthContextType и начальными значениями по умолчанию
const AuthContext = React.createContext<AuthContextType>({
    isAuthenticated: false,
    setAuth: () => {},
    roles: ['anonymous'],
    setRoles: () => {},
    user: {id: 0, login: 'anonymous', name: 'anonymous', avatar: ''},
    setUser: () => {},
});

// Создаем компонент провайдера, который предоставляет данные контекста всем дочерним компонентам
export const AuthProvider = ({ children }: { children: React.JSX.Element }) => {
    // Используем хук useState для создания переменной isAuthenticated и функции setAuth для ее изменения
    const [isAuthenticated, setAuth] = React.useState<boolean>(false);
    const [roles, setRoles] = React.useState<string[]>(['anonymous']);
    const [user, setUser] = React.useState<UserType>({id: 0, login: 'anonymous', name: 'anonymous', avatar: ''});

    React.useEffect(() => {
        if (localStorage.getItem('token')) {
            setAuth(true);
        }
        if (localStorage.getItem('roles')) {
            const s = localStorage.getItem('roles');
            if (s) {
                setRoles(JSON.parse(s));
            }
        }
        if (localStorage.getItem('user')) {
            const s = localStorage.getItem('user');
            if (s) {
                setUser(JSON.parse(s));
            }
        }
    }, [])

    // Возвращаем контекст провайдера, передавая значения isAuthenticated и setAuth в качестве значения контекста
    return (
        <AuthContext.Provider value={{ isAuthenticated, setAuth, roles, setRoles, user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;

